namespace $.$$ {
	export class $shm_hitalama_map_widget_float_code_panel extends $.$shm_hitalama_map_widget_float_code_panel {

		panel_content() {
			return [
				... this.no_crdt() ? [ this.No_crdt_label() ] : [],
				this.Download(),
				this.Templates(),
				this.Autorun_enabled(),
				this.Run(),
			]
		}

	}
}
